import React, { useEffect, useState, useCallback, useRef } from "react";

import { throttle } from "@/utils/index";

export const useGenerateRefAndState = (initState) => {
  const [state, setState] = useState(initState)
  const stateRef = useRef(state)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  const _setState = (value) => {
    stateRef.current = value
    setState(value)
  }

  return [state, _setState, stateRef]
}

export const useGenerateRefByState = (state) => {
  const stateRef = useRef(state)

  useEffect(() => {
    stateRef.current = state
  }, [state])

  return stateRef
}

export const useGenerateMapRefAndState = (initState) => {
  const [state, setState] = useState(initState)
  const stateRef = useRef(state)

  const setKeyValue = (key, value) => {
    if (!(key in stateRef.current)) {
      console.error('key is not correct')
      return
    }
    const newState = { ...stateRef.current, [key]: value }
    setState(newState)
    stateRef.current = newState
  }

  return [state, stateRef, setKeyValue, setState]
}

export const useLongPress = (isMobileRef, longPressFn, shortPressFn) => {
  const startTime = useRef(0)
  const timer = useRef(0)
  const touchDistance = useRef({
    y: 0,
    len: 0
  })

  const startFn = (ev) => {
    if (!isMobileRef.current) {
      return
    }

    touchDistance.current = {
      y: 0,
      len: 0
    }
    startTime.current = new Date().getTime()
    timer.current = setTimeout(longPressFn, 600)
    if (ev.touches && ev.touches.length) {
      const { clientX, clientY } = ev.touches[0]
      touchDistance.current.y = clientY
    }
  }
  const moveFn = (ev) => {
    if (!isMobileRef.current) {
      return
    }

    if (ev.touches && ev.touches.length) {
      const clientY = ev.touches[0].clientY
      touchDistance.current = {
        y: clientY,
        len: touchDistance.current.len + Math.abs(clientY - touchDistance.current.y)
      }
    }
  }
  const stopLongPressFn = () => timer.current && clearTimeout(timer.current)
  const endFn = (ev) => {
    if (!isMobileRef.current) {
      return true
    }

    // console.log('endFn', touchDistance.current.len, new Date().getTime() - startTime.current)
    if (touchDistance.current.len > 30) {
      stopLongPressFn()
      return true
    }

    if (new Date().getTime() - startTime.current < 400) {
      stopLongPressFn()
      shortPressFn(ev)
    }
    startTime.current = 0
  }
  return [startFn, moveFn, endFn]
}

export const useScrollEndLoadMore = (wrapperRef, loadMoreFn, preReachEndDistance = 50, trigger = 1) => {
  const [loading, setLoading] = useState(false)
  const fn = async () => {
    if (loading) {
      return
    }
    
    setLoading(true)
    await loadMoreFn()
    setLoading(false)
  }
  const fnRef = useGenerateRefByState(fn)

  useEffect(() => {
    const listenerDom = wrapperRef ? wrapperRef.current : window
    const wrapper = wrapperRef ? wrapperRef.current : document.documentElement
    const scrollFn = throttle((ev) => {
      const scrollTop = wrapperRef ? ev.target.scrollTop : wrapper.scrollTop
      const clientHeight = wrapper.clientHeight
      const scrollHeight = wrapper.scrollHeight
      if (scrollTop + clientHeight > scrollHeight - preReachEndDistance) {
        fnRef.current()
      }
    }, 300)

    if (listenerDom) {
      listenerDom.addEventListener('scroll', scrollFn)
    }
    
    return () => {
      if (listenerDom) {
        listenerDom.removeEventListener('scroll', scrollFn)
      }
    }
  }, [trigger])
}
